<template>
    <transition name="fade">
        <div v-if="visible" class="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
            @click.self="closeOnBackdrop && $emit('close')">
            <!-- ✅ Ici on injecte le contenu -->
            <slot />
        </div>
    </transition>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
defineProps({
    visible: { type: Boolean, default: false }, // état visible/invisible
    closeOnBackdrop: { type: Boolean, default: true } // ferme si on clique dehors
})
defineEmits(["close"])
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
